// Google Ads (Google Tag) Anbindung.
//
// Wichtig: AW-IDs werden ueber die gtag-Kommando-API angesprochen, NICHT ueber
// einen dataLayer-Push mit { event: "conversion" }. Der Container zu AW-11081935266
// enthaelt ausschliesslich Regeln fuer die Events "gtm.js" und "gtm.init" - ein
// Event namens "conversion" triggert dort nichts, und "send_to" wird bei einem
// normalen Objekt-Push nicht ausgewertet. Conversions muessen deshalb ueber
// gtag("event", "conversion", { send_to: "<AW-ID>/<Label>" }) laufen.

const AW_ID = "AW-11081935266";
const CONVERSION_LABEL = "M2_DCJKVwKQbEKLTo6Qp";

const LINKER_DOMAINS = [
  "feuersozietaet.de",
  "www.feuersozietaet.de",
  "sicherelaube.de",
  "www.sicherelaube.de",
  "dev.sicherelaube.de",
];

window.dataLayer = window.dataLayer || [];

// Muss eine klassische function sein: gtag reicht das arguments-Objekt weiter,
// genau so erkennt der Google Tag den Eintrag als Kommando (und nicht als Event-Objekt).
export function gtag() {
  window.dataLayer.push(arguments);
}

window.gtag = gtag;

let initialized = false;

export function hasMarketingConsent() {
  return !!(
    window.Cookiebot &&
    window.Cookiebot.consent &&
    window.Cookiebot.consent.marketing
  );
}

export function initGtag() {
  if (initialized || !hasMarketingConsent()) return false;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  gtag("set", "linker", { domains: LINKER_DOMAINS });
  gtag("config", AW_ID);

  return true;
}

// Feuert die Google-Ads-Conversion. Gibt zurueck, ob gesendet wurde.
export function trackConversion({ valueCents, transactionId }) {
  if (!hasMarketingConsent()) return false;

  // Falls der Consent erst nach dem Seitenaufbau erteilt wurde.
  initGtag();

  const params = {
    send_to: `${AW_ID}/${CONVERSION_LABEL}`,
    currency: "EUR",
    transaction_id: transactionId ? String(transactionId) : "",
  };

  const cents = Number(valueCents);
  if (Number.isFinite(cents)) {
    // Google Ads erwartet eine Zahl, kein formatiertes String-Ergebnis.
    params.value = Math.round(cents) / 100;
  }

  gtag("event", "conversion", params);

  return true;
}
